import React from 'react'
import {
  questDesigner,
  publisher,
  internalReviewer,
  oeReviewer,
  externalReviewer,
  copyEditor
} from './messages'
import { userCertifications } from '../constants/usercertifications'

function isUserInRole(user, role) {
  return (
    user.organization_roles.filter(function (orgRole) {
      return orgRole === role
    }).length > 0
  )
}

export function isQuestAuthor(user, quest, organization) {
  return (
    user &&
    quest.author_ids.includes(user.id) &&
    organization &&
    organization.orgId === quest.organization.id
  )
}

export function isInternalReviewer(user) {
  return isUserInRole(user, 'qm_internal_review')
}

export function isOeReviewer(user) {
  return isUserInRole(user, 'qm_platform_review')
}

export function isQuestDesigner(user) {
  return isUserInRole(user, 'qm_editor')
}

export function isQuestCopyEditor(user) {
  return isUserInRole(user, 'qm_copy_editor')
}

export function isExternalReviewer(user) {
  return isUserInRole(user, 'qm_external_review')
}

export function isQuestCopyEditorOrQuestAuthor(user, quest, organization) {
  return isQuestCopyEditor(user) || isQuestAuthor(user, quest, organization)
}

export function isQuestManager(user) {
  return isUserInRole(user, 'qm_quest_manager')
}

export function isMentorAuthor(user) {
  return isUserInRole(user, 'qm_mentor_author')
}

export function getDisplayRole(roles) {
  let displayRole = questDesigner

  if (roles.indexOf('qm_publisher') > -1) {
    displayRole = publisher
  }

  if (roles.indexOf('qm_internal_review') > -1) {
    displayRole = internalReviewer
  }

  if (roles.indexOf('qm_platform_review') > -1) {
    displayRole = oeReviewer
  }

  if (roles.indexOf('qm_external_review') > -1) {
    displayRole = externalReviewer
  }

  if (roles.indexOf('qm_copy_editor') > -1) {
    displayRole = copyEditor
  }

  if (roles.indexOf('qm_quest_manager') > -1) {
    displayRole = 'Quest Manager'
  }

  if (roles.indexOf('qm_mentor_author') > -1) {
    displayRole = 'Mentor Author'
  }

  return displayRole
}

export function isQuestAuthorOrInternalReviewer(user, quest, organization) {
  return (
    isQuestAuthor(user, quest, organization) ||
    isInternalReviewer(user) ||
    isQuestManager(user)
  )
}

export function isInternalReviewerOrOeReviewer(user) {
  return isInternalReviewer(user) || isOeReviewer(user)
}

export function isQuestDesignerOrIsQuestManager(user) {
  return isQuestDesigner(user) || isQuestManager(user)
}

export function isQuestCopyEditorOrQuestAuthorOrQuestManager(
  user,
  quest,
  organization
) {
  return (
    isQuestCopyEditorOrQuestAuthor(user, quest, organization) ||
    isQuestManager(user)
  )
}

export function getUserCertificationMarkerTooltipText(certifications) {
  let text = ''
  userCertifications.forEach(role => {
    const roleCert = certifications.find(c => c.certificate_type === role.value)
    if (roleCert) {
      const provisional = roleCert.level === 'provisional'
      text += `<div style="margin-top: 5px">${role.text}${
        provisional ? ' (Provisional)' : ''
      }</div>`
    }
  })

  return <div dangerouslySetInnerHTML={{ __html: text }} />
}



// WEBPACK FOOTER //
// ./src/utils/user.js